(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-landing-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.TJB2BPriceCollages) {
    window.TJB2BPriceCollages = {
      shuffle: function (products) {
        for (var index = products.length - 1; index > 0; index -= 1) {
          var randomIndex = Math.floor(Math.random() * (index + 1));
          var currentProduct = products[index];
          products[index] = products[randomIndex];
          products[randomIndex] = currentProduct;
        }
        return products;
      },
      bands: function (collage) {
        return {
          below: Array.from(collage.querySelectorAll('[data-price-band="below"]')),
          above: Array.from(collage.querySelectorAll('[data-price-band="above"]'))
        };
      },
      loadPage: async function (sectionId, page) {
        var url = new URL(window.location.href);
        url.searchParams.set('sections', sectionId);
        url.searchParams.set('page', String(page));
        var response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) return [];
        var sections = await response.json();
        if (!sections[sectionId]) return [];
        var parsed = new DOMParser().parseFromString(sections[sectionId], 'text/html');
        return Array.from(parsed.querySelectorAll('[data-b2b-price-collage] .b2be-candidate'));
      },
      fill: async function (collage) {
        collage.dataset.b2bLoading = 'true';
        collage.setAttribute('aria-busy', 'true');
        var bands = window.TJB2BPriceCollages.bands(collage);
        var page = Number(collage.dataset.currentPage || 1) + 1;
        var totalPages = Math.min(Number(collage.dataset.totalPages || 1), 10);
        var sectionId = collage.dataset.sectionId;
        var existingUrls = new Set(Array.from(collage.querySelectorAll('.b2be-candidate')).map(function (product) {
          return product.getAttribute('href');
        }));

        while ((bands.below.length < 2 || bands.above.length < 2) && page <= totalPages) {
          var additionalProducts = await window.TJB2BPriceCollages.loadPage(sectionId, page);
          var label = collage.querySelector('.b2be-collage-label, .b2bm-label');

          additionalProducts.forEach(function (product) {
            var productUrl = product.getAttribute('href');
            if (existingUrls.has(productUrl)) return;
            existingUrls.add(productUrl);
            product.hidden = true;
            product.removeAttribute('data-visible-position');
            collage.insertBefore(product, label);
          });

          bands = window.TJB2BPriceCollages.bands(collage);
          page += 1;
        }

        var below = window.TJB2BPriceCollages.shuffle(bands.below).slice(0, 2);
        var above = window.TJB2BPriceCollages.shuffle(bands.above).slice(0, 2);
        var selected = below.concat(above);

        collage.querySelectorAll('.b2be-candidate').forEach(function (product) {
          product.hidden = true;
          product.removeAttribute('data-visible-position');
        });

        selected.forEach(function (product, index) {
          product.hidden = false;
          product.dataset.visiblePosition = String(index + 1);
        });

        collage.dataset.b2bRandomized = 'true';
        delete collage.dataset.b2bLoading;
        collage.removeAttribute('aria-busy');
      },
      randomize: function (root) {
        root.querySelectorAll('[data-b2b-price-collage]:not([data-b2b-randomized]):not([data-b2b-loading])').forEach(function (collage) {
          window.TJB2BPriceCollages.fill(collage).catch(function () {
            delete collage.dataset.b2bLoading;
            collage.removeAttribute('aria-busy');
          });
        });
      }
    };

    document.addEventListener('shopify:section:load', function (event) {
      window.TJB2BPriceCollages.randomize(event.target);
    });
  }

  window.TJB2BPriceCollages.randomize(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-landing-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.TJB2BPriceCollages) {
    window.TJB2BPriceCollages = {
      shuffle: function (products) {
        for (var index = products.length - 1; index > 0; index -= 1) {
          var randomIndex = Math.floor(Math.random() * (index + 1));
          var currentProduct = products[index];
          products[index] = products[randomIndex];
          products[randomIndex] = currentProduct;
        }
        return products;
      },
      bands: function (collage) {
        return {
          below: Array.from(collage.querySelectorAll('[data-price-band="below"]')),
          above: Array.from(collage.querySelectorAll('[data-price-band="above"]'))
        };
      },
      loadPage: async function (sectionId, page) {
        var url = new URL(window.location.href);
        url.searchParams.set('sections', sectionId);
        url.searchParams.set('page', String(page));
        var response = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) return [];
        var sections = await response.json();
        if (!sections[sectionId]) return [];
        var parsed = new DOMParser().parseFromString(sections[sectionId], 'text/html');
        return Array.from(parsed.querySelectorAll('[data-b2b-price-collage] .b2be-candidate'));
      },
      fill: async function (collage) {
        collage.dataset.b2bLoading = 'true';
        collage.setAttribute('aria-busy', 'true');
        var bands = window.TJB2BPriceCollages.bands(collage);
        var page = Number(collage.dataset.currentPage || 1) + 1;
        var totalPages = Math.min(Number(collage.dataset.totalPages || 1), 10);
        var sectionId = collage.dataset.sectionId;
        var existingUrls = new Set(Array.from(collage.querySelectorAll('.b2be-candidate')).map(function (product) {
          return product.getAttribute('href');
        }));

        while ((bands.below.length < 2 || bands.above.length < 2) && page <= totalPages) {
          var additionalProducts = await window.TJB2BPriceCollages.loadPage(sectionId, page);
          var label = collage.querySelector('.b2be-collage-label, .b2bm-label');

          additionalProducts.forEach(function (product) {
            var productUrl = product.getAttribute('href');
            if (existingUrls.has(productUrl)) return;
            existingUrls.add(productUrl);
            product.hidden = true;
            product.removeAttribute('data-visible-position');
            collage.insertBefore(product, label);
          });

          bands = window.TJB2BPriceCollages.bands(collage);
          page += 1;
        }

        var below = window.TJB2BPriceCollages.shuffle(bands.below).slice(0, 2);
        var above = window.TJB2BPriceCollages.shuffle(bands.above).slice(0, 2);
        var selected = below.concat(above);

        collage.querySelectorAll('.b2be-candidate').forEach(function (product) {
          product.hidden = true;
          product.removeAttribute('data-visible-position');
        });

        selected.forEach(function (product, index) {
          product.hidden = false;
          product.dataset.visiblePosition = String(index + 1);
        });

        collage.dataset.b2bRandomized = 'true';
        delete collage.dataset.b2bLoading;
        collage.removeAttribute('aria-busy');
      },
      randomize: function (root) {
        root.querySelectorAll('[data-b2b-price-collage]:not([data-b2b-randomized]):not([data-b2b-loading])').forEach(function (collage) {
          window.TJB2BPriceCollages.fill(collage).catch(function () {
            delete collage.dataset.b2bLoading;
            collage.removeAttribute('aria-busy');
          });
        });
      }
    };

    document.addEventListener('shopify:section:load', function (event) {
      window.TJB2BPriceCollages.randomize(event.target);
    });
  }

  window.TJB2BPriceCollages.randomize(document);

  } catch(e) { console.error(e); }
})();
})();
